import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProjectCompetitorsArrayModel,
  ProjectCompetitorsModel,
} from "../../models/ProjectCompetitorsModel";

const initialProjectCompetitorState: ProjectCompetitorsArrayModel = {
  all_ProjectCompetitors: [],
  particular_ProjectCompetitor: {
    id: 0,
    name: "",
  },
  isProjectCompetitorsFetching: false,
};
const ProjectCompetitorsSlice = createSlice({
  name: "ProjectCompetitors",
  initialState: initialProjectCompetitorState,
  reducers: {
    setProjectCompetitors(
      state,
      action: PayloadAction<ProjectCompetitorsModel[]>
    ) {
      state.all_ProjectCompetitors = action.payload;
    },
    setParticularProjectCompetitor(
      state,
      action: PayloadAction<ProjectCompetitorsModel>
    ) {
      state.particular_ProjectCompetitor = action.payload;
    },
    setIsProjectCompetitorsFetching(state, action: PayloadAction<boolean>) {
      state.isProjectCompetitorsFetching = action.payload;
    },
  },
});
export default ProjectCompetitorsSlice;
